import { Flex } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import Filters from "../../components/Filters";
import MainMetrics from "../../components/MainMetrics";
import useFlowDetectionsProcessData from "../../hooks/useFlowDetectionsProcessData";
import useHomeRevenueKPIsData from "../../hooks/useHomeRevenueKPIsData";
import { REVENUE_KPIS_METRICS } from "../../utils/constants";
import RevenueCardChart from "./RevenueCardChart";

const InitialDateRange = () => {
  const today = dayjs().format("YYYY-MM-DD");
  const oneWeekAgo = dayjs().subtract(7, "day").format("YYYY-MM-DD");
  const date_range = [oneWeekAgo, today];
  return date_range;
};

export default function RevenueRefact() {
  const [selectedDateRange, setSelectedDateRange] =
    useState(InitialDateRange());
  const [selectedZones, setSelectedZones] = useState(["all"]);
  const [selectedCollections, setSelectedCollections] = useState(["all"]);

  const { data: kpiData, isLoading: isLoadingKpiData } = useHomeRevenueKPIsData(
    selectedDateRange?.[0] || InitialDateRange()[0],
    selectedDateRange?.[1] || InitialDateRange()[1],
    selectedCollections,
    selectedZones
  );

  return (
    <Flex
      vertical
      gap={50}
      justify="center"
      align="center"
      style={{ width: "100%", margin: "0 auto" }}>
      <Filters
        page="revenue"
        dateRange={true}
        selectedDateRange={selectedDateRange}
        setSelectedDateRange={setSelectedDateRange}
        selectedZones={selectedZones}
        setSelectedZones={setSelectedZones}
        selectedCollections={selectedCollections}
        setSelectedCollections={setSelectedCollections}
        filters={["data", "zonas", "colecoes"]}
      />
      <MainMetrics
        data={kpiData?.geral}
        isLoading={isLoadingKpiData}
        kpis={REVENUE_KPIS_METRICS}
        revenueKPIsData={kpiData?.geral}
      />
      <RevenueCardChart
        selectedDateRange={selectedDateRange}
        selectedZones={selectedZones}
        selectedCollections={selectedCollections}
      />
    </Flex>
  );
}
